import { useMemo } from 'react'

import { Scope } from '../../../enums/scope'
import { useScopedFeatureAccess } from '../../../hooks/useScopedFeatureAccess'

interface ScoutAccess {
  isLockedByUpsell: boolean
  shouldShowScout: boolean
}

export const useScoutAccess = (): ScoutAccess => {
  const { isLockedByUpsell, shouldShowFeature } = useScopedFeatureAccess(Scope.ScoutWrite, Scope.ScoutUpsell)

  return useMemo(
    () => ({
      isLockedByUpsell,
      shouldShowScout: shouldShowFeature,
    }),
    [isLockedByUpsell, shouldShowFeature],
  )
}
